import { ApiKey, ApiPathManager } from "app/shared/services/api-path";
import { getDataHeaders, getUserHeader } from "app/shared/services/header-builder";
import { REQUESTINPUT } from "app/shared/services/services-model.type";
import { instance } from "app/shared/util/token-store";
import moment from "moment";
import { FetchStatementBackupRequest, FetchStatementDetailRequest, FetchStatementV2Request } from "../reducer/types";

export const fetchStatementBackupService = async (actionRq: FetchStatementBackupRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.ACCOUNT_STATEMENT_BACKUP);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ACCOUNTPROFILE: {
      ACCOUNTNO: actionRq.payload?.accountNo,
      ACCOUNTTYPE: actionRq.payload?.accountType,
    },
    STATEMENT: {
      FROMDATE: actionRq.payload?.fromDate,
      TODATE: actionRq.payload?.toDate,
    },
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchStatementV2Service = async (actionRq: FetchStatementV2Request) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.ACCOUNT_STATEMENT_V2);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const fromDate = moment(actionRq.payload?.fromDate, "DD/MM/YYYY").format("YYYYMMDD");
  const toDate = moment(actionRq.payload?.toDate, "DD/MM/YYYY").format("YYYYMMDD");
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ACCOUNTPROFILE: {
      ACCOUNTNO: actionRq.payload?.accountNo,
      ACCOUNTTYPE: actionRq.payload?.accountType,
    },
    STATEMENT: {
      FROMDATE: fromDate,
      TODATE: toDate,
    },
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchStatementDetailService = async (actionRq: FetchStatementDetailRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.ACCOUNT_STATEMENT_DETAIL_V2);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  // Convert time to YYYYMMDD
  const transDate = moment(actionRq.payload?.TRANSACTION_DATE, "DD/MM/YYYY").format("YYYYMMDD");
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    TRANSFER: {
      SEQUENCE_NUMBER: actionRq.payload?.SEQUENCE_NUMBER,
      TRANSACTION_DATE: transDate,
    },
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};
